import { Card } from '@/components/ui/card';
import {
  ComposedChart, Line, Bar, XAxis, YAxis, CartesianGrid, Tooltip, ResponsiveContainer, ReferenceLine,
} from 'recharts';
import { t, getLocale } from '@/i18n';

const dayLabel = (iso) => new Date(iso).toLocaleDateString(getLocale(), { day: 'numeric', month: 'numeric' });

// Daily trend of one or more series, with a vertical line where the pilot started.
export const TrendChart = ({ title, hint, rows, series, pilotDate, unit = '' }) => (
  <Card className="p-4">
    <div className="text-sm font-semibold">{title}</div>
    {hint && <div className="text-xs text-muted-foreground">{hint}</div>}
    <div className="h-48 mt-3">
      <ResponsiveContainer width="100%" height="100%">
        <ComposedChart data={rows} margin={{ top: 8, right: 8, left: -20, bottom: 0 }}>
          <CartesianGrid strokeDasharray="3 3" vertical={false} stroke="hsl(var(--border))" />
          <XAxis dataKey="date" tickFormatter={dayLabel} tick={{ fontSize: 10 }} minTickGap={24} />
          <YAxis tick={{ fontSize: 10 }} allowDecimals={false} />
          <Tooltip
            labelFormatter={dayLabel}
            formatter={(value, name) => [`${value}${unit}`, name]}
          />
          {pilotDate && (
            <ReferenceLine x={pilotDate} stroke="hsl(var(--primary))" strokeDasharray="4 3" label={{ value: t('stats.pilotStart'), fontSize: 10, position: 'insideTopLeft' }} />
          )}
          {series.map(s => (s.type === 'bar'
            ? <Bar key={s.key} dataKey={s.key} name={s.name} stackId={s.stack} fill={s.color} />
            : <Line key={s.key} dataKey={s.key} name={s.name} stroke={s.color} dot={false} strokeWidth={2} />
          ))}
        </ComposedChart>
      </ResponsiveContainer>
    </div>
  </Card>
);
